import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 bg-white" data-id="element-148">
      <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-149">
        <div className="inline-flex items-center justify-center w-24 h-24 bg-brand-light rounded-full mb-8" data-id="element-150">
          <ShieldCheck className="w-12 h-12 text-brand-blue" data-id="element-151" />
        </div>

        <h2 className="text-3xl md:text-4xl font-heading font-bold text-gray-900 mb-8" data-id="element-152">
          Garantía 7 días sin preguntas
        </h2>

        <div className="bg-gray-50 rounded-2xl p-8 md:p-12 border border-gray-200 mb-8 text-lg text-gray-700 leading-relaxed" data-id="element-153">
          <p className="mb-6 font-medium" data-id="element-154">
            Abrí los 12 Tomos.
            <br data-id="element-155" />
            Revisá los 6 Bonus.
            <br data-id="element-156" />
            Usá los Ebooks Élite en tu pileta.
          </p>
          <p className="mb-6 font-bold text-brand-blue text-xl" data-id="element-157">
            Si no es lo que esperabas → 100% de devolución.
          </p>
          <p className="text-gray-500" data-id="element-158">
            Sin preguntas. Sin formularios. Sin drama.
          </p>
        </div>

        <div className="inline-block bg-green-100 text-green-800 font-bold px-6 py-2 rounded-full text-sm tracking-wider" data-id="element-159">
          TASA DE DEVOLUCIONES MENOR AL 2%
        </div>
      </div>
    </section>;
}